import { toJss } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import classnames from "classnames"
import jss from "jss"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import styles from "./index.less"

class Title extends C {
  static dynamicStyles = null
  static displayName = "Title_Eas"

  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.node.isRequired,
  }

  constructor(props) {
    super(props)

    if (Title.dynamicStyles == null) {
      const dynamicStylesConfig = toJss(props.skinObject.pageTitle || {}, {
        pageTitle: {
          color: v.blue120,
        },
      })

      Title.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  render() {
    const { classes } = Title.dynamicStyles
    const titleClass = classnames(styles.pageTitle, classes.pageTitle, this.props.className)

    return (
      <div className={classnames(this.props.containerClassName, styles.globalPageTitle)}>
        <h2 className={titleClass}>{this.props.title}</h2>
      </div>
    )
  }
}

export default withSkin(Title)
